import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FileDTODocumentTypeEnum } from '@ringo/shared'
import { TranslationKeys, useTranslation } from '../../../useTranslation'

interface FileUploadFieldProps {
    text: TranslationKeys
    documentType: any
    onShowPreview: (documentType: FileDTODocumentTypeEnum) => void
    previewAvailable: boolean
    setSelectedDocumentType: (documentType: FileDTODocumentTypeEnum) => void
}

const FileUploadField = ({ text, documentType, onShowPreview, previewAvailable, setSelectedDocumentType }: FileUploadFieldProps) => {
    const { t } = useTranslation()
    return (
        <div className="relative w-1/3" key={text}>
            <div className={`border border-gray-300 mb-4 py-2.5 relative flex justify-start px-4  ${previewAvailable && 'bg-green-100 border-green-100'}`}>
                {previewAvailable && (
                    <FontAwesomeIcon icon={['fas', 'circle-check']} className="text-sm max-tablet:text-xs text-green-400 text-[12px] mr-1.5 -ml-2" />
                )}
                <p className="text-xs text-black max-tablet:text-xs">{t(text)}</p>
            </div>
            <div className="absolute right-0 -top-0.5  px-3 py-3  ">
                {previewAvailable && (
                    <FontAwesomeIcon
                        icon={['fas', 'eye']}
                        className="text-sm max-tablet:text-xs text-blue-800 bg-white p-1 rounded-xs text-[12px] mr-1.5 cursor-pointer"
                        onClick={() => onShowPreview(documentType)}
                    />
                )}
                <label htmlFor={'fileLabel'} onClick={() => setSelectedDocumentType(documentType)}>
                    <FontAwesomeIcon
                        icon={['fas', 'cloud-arrow-up']}
                        className="text-sm max-tablet:text-xs text-custom_yellow bg-white p-1 rounded-xs text-[12px] cursor-pointer"
                    />
                </label>
            </div>
        </div>
    )
}

export default FileUploadField
